import React from 'react';
import IframePage from '../shared/IframePage';

const TemplatesPage = () => {
    return <IframePage iframePath="schemas" pageName="TemplatesPage" />;
};

export default TemplatesPage;
